module.exports = __webpack_public_path__ + "static/img/bigWheel1.30d5020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bigWheel1.png
// module id = JRJ5
// module chunks = 2